// extracted by mini-css-extract-plugin
export default {"modalWrapper":"Modal_modalWrapper__ZSORB","modalContent":"Modal_modalContent__JODE3","button":"Modal_button__FFRRp"};